// extracted by mini-css-extract-plugin
export default {"Link":"📚19-10-2_PYla"};